import React from 'react';
import { ScrollToTop as Design } from 'cb-design-system';

const ScrollToTop = () => (
  <Design />
)

export default ScrollToTop;
